import React from "react";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import axios from "axios";
import API from "../helpers/api";
import swal from "sweetalert";
let currentUser = JSON.parse(localStorage.getItem("currentUser"));
class EditExecutive extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            techExecutiveInfo: {
                clientUserId: 0,
                clientId: 0,
                userRole: "technicalexecutive",
                userName: "",
                email: "",
                telephone: '',
                modifiedBy: "",
                isDeleted: false,
            },
            index: 0,
            techExecutiveArray: []
        }
        this.handleInputChange = this.handleInputChange.bind(this);
        this.updateTechExecutive = this.updateTechExecutive.bind(this);
        this.addTechExecutive = this.addTechExecutive.bind(this);
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        const { techExecutiveList, techExecutiveDetail, dispatch } = nextProps;
        if (techExecutiveDetail) {
            prevState.techExecutiveInfo.clientUserId = techExecutiveDetail.clientUserId;
            prevState.techExecutiveInfo.clientId = techExecutiveDetail.clientId;
            prevState.techExecutiveInfo.userName = techExecutiveDetail.userName;
            prevState.techExecutiveInfo.email = techExecutiveDetail.email;
            prevState.techExecutiveInfo.telephone = techExecutiveDetail.telephone;
            prevState.index = techExecutiveList.findIndex(x => x.email === techExecutiveDetail.email);
            dispatch({ type: "GetTechExecutiveDetails", data: null });
        }
        if (techExecutiveList) {
            prevState.techExecutiveArray = techExecutiveList;
        }
    }

    // handleInputChange(e) {
    //     let nodeName = e.target.name;
    //     this.state.techExecutiveInfo[nodeName] = e.target.value;
    //     this.setState({});
    // }
    handleInputChange(e) {
        let nodeName = e.target.name;
        const regex = /^\d*$/;
        if (nodeName == 'telephone') {
            if (regex.test(e.target.value)) {
                this.state.techExecutiveInfo[nodeName] = e.target.value;
            }
        }
        else {
            this.state.techExecutiveInfo[nodeName] = e.target.value;
        }

        this.setState({});
    }

    addTechExecutive() {
        const {
            dispatch,
            match,
            fleetManagerList,
            techSuperintendentList,
            techExecutiveList,
        } = this.props;
        const { params } = match;
        const { id } = params;
        let userArray = [];
        let executive = {
            clientId: parseInt(id),
            userRole: "technicalexecutive",
            userName: this.state.techExecutiveInfo.userName,
            email: this.state.techExecutiveInfo.email,
            telephone: this.state.techExecutiveInfo.telephone,
            createdBy: ""
        }
        userArray.push(executive);
        let emailregex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (this.state.techExecutiveInfo.email !== "") {
            if (emailregex.test(this.state.techExecutiveInfo.email)) {
                const enteredEmail = this.state.techExecutiveInfo.email.trim();
                const normalizedEmail = enteredEmail.toLowerCase();
                const emailExistsInClient =
                    (fleetManagerList || []).some(
                        (x) => x?.email?.trim().toLowerCase() === normalizedEmail
                    ) ||
                    (techSuperintendentList || []).some(
                        (x) => x?.email?.trim().toLowerCase() === normalizedEmail
                    ) ||
                    (techExecutiveList || []).some(
                        (x) => x?.email?.trim().toLowerCase() === normalizedEmail
                    );

                if (emailExistsInClient) {
                    swal(
                        "Error!",
                        `User with email ${enteredEmail} already exists in this client.`,
                        "warning"
                    );
                    return;
                }

                let url2 = `${API.userExist}?Mail=${this.state.techExecutiveInfo.email}`
                axios.get(url2, {
                    headers: {
                        key: currentUser.accessToken
                    }
                })
                    .then((response) => {
                        if (response.data === true) {
                            let url = `${API.postClientuser}`;
                            axios.post(url, userArray, {
                                headers: {
                                    key: currentUser.accessToken
                                }
                            })
                                .then((response) => {
                                    let url = `${API.getClientUsers}?clientId=${id}`;
                                    axios.get(url)
                                        .then((response) => {
                                            let fleetManager = response.data && response.data.filter(r => r.userRole === "fleetmanager");
                                            let techSuperintendent = response.data && response.data.filter(r => r.userRole === "superintendent");
                                            let techExecutive = response.data && response.data.filter(r => r.userRole === "technicalexecutive");
                                            dispatch({ type: "GetFleetManagerlist", data: fleetManager });
                                            dispatch({ type: "GetTechSuperintendentlist", data: techSuperintendent });
                                            dispatch({ type: "GetTechExecutivelist", data: techExecutive });
                                            dispatch({
                                                type: "getClientUsersListSuccess",
                                                data: response.data,
                                            })
                                        })
                                        .catch((error) => {
                                            dispatch({
                                                type: "getClientUsersDetailsFailure",
                                                error: "ERROR"
                                            })
                                        })
                                    this.hideSidePanel();
                                    dispatch({
                                        type: "postClientUserDetailSuccess",
                                        data: response.data,
                                    })
                                })
                                .catch((error) => {
                                    dispatch({
                                        type: "postClientUserDetailFailure",
                                        error: "ERROR"
                                    })
                                })
                        } else if (response.data === false) {
                            swal('Error!', 'User already exists.', 'warning');
                            this.state.techExecutiveInfo.email = "";
                            this.setState({});
                        }
                        dispatch({
                            type: 'getUserExistListSuccess',
                            data: response.data
                        })
                    })
                    .catch((error) => {
                        dispatch({
                            type: 'getUserExistListFailure',
                            data: "error"
                        })
                    })
            }
            else {
                swal('Error!', 'Invalid email format', 'warning');
            }
        } else {
            swal('Error!', 'Email is mandatory', 'warning');
        }
    }

    updateTechExecutive() {
        let emailregex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        const { techExecutiveInfo } = this.state;
        const { fleetManagerList, techSuperintendentList, techExecutiveList } = this.props;
        // this.state.techExecutiveArray[index] = techExecutiveInfo;
        var index = this.state.techExecutiveArray.findIndex(x => x.clientUserId === techExecutiveInfo.clientUserId || x.email === techExecutiveInfo.email);
        if (this.state.techExecutiveInfo.email !== "") {
            if (emailregex.test(this.state.techExecutiveInfo.email)) {
                const enteredEmail = this.state.techExecutiveInfo.email.trim();
                const normalizedEmail = enteredEmail.toLowerCase();
                const emailExistsInClient =
                    (fleetManagerList || []).some(
                        (x) => x?.email?.trim().toLowerCase() === normalizedEmail
                    ) ||
                    (techSuperintendentList || []).some(
                        (x) => x?.email?.trim().toLowerCase() === normalizedEmail
                    ) ||
                    (techExecutiveList || []).some(
                        (x) =>
                            x?.clientUserId !== techExecutiveInfo.clientUserId &&
                            x?.email?.trim().toLowerCase() === normalizedEmail
                    );

                if (emailExistsInClient) {
                    swal(
                        "Error!",
                        `User with email ${enteredEmail} already exists in this client.`,
                        "warning"
                    );
                    return;
                }

                this.state.techExecutiveArray[index] = techExecutiveInfo;
                this.setState({});
                this.props.dispatch({ type: "GetTechExecutivelist", data: this.state.techExecutiveArray });
                this.hideSidePanel();
            }
            else {
                swal('Error!', 'Invalid email format', 'warning');
            }
        }
        else {
            swal('Error!', 'Email is mandatory', 'warning');
        }
    }

    hideSidePanel() {
        const { dispatch, match } = this.props;
        const { params } = match;
        const { id } = params;
        // this.props.history.goBack();
        this.props.dispatch({ type: "ShowSidePan", data: false });
        this.props.history.push(`/Home/Management/ClientEdit/${id}`);
    }

    render() {
        const { EditUser } = this.props;
        return (
            <div className="full-height">
                <div className="resource-list-auth-date row pt-3 ">
                    <div className='w-100'>
                        <div className="panel-box search-filter-box">
                            <button
                                className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                                onClick={() => this.hideSidePanel()}
                            >
                                <div style={{ position: 'relative' }}>
                                    <span className="backarr">&larr;</span> <span style={{ marginLeft: "18px" }}>Return</span>
                                </div>
                            </button>
                            <div className="card mt-2 MM-card-header" style={{ backgroundColor: "white" }}>
                                <div className="card-body" style={{ padding: "0rem", backgroundColor: "#1a3464", color: "white" }}><h5 className="card-title ml-4 mt-2" style={{ color: "092a51" }}>DPA</h5></div>
                            </div>
                            <div className="row search-filter-box">
                                <div className="col-lg-6">
                                    <label className="form-label">Name</label><br></br>
                                    <input type="text" className="form-control" name='userName' value={this.state.techExecutiveInfo.userName} placeholder="Name" onChange={e => this.handleInputChange(e)}></input>
                                </div>
                                <div className="col-lg-6">
                                    <label className="form-label">Email<span className="mandatory">*</span></label><br></br>
                                    <input type="email" className="form-control" name='email' value={this.state.techExecutiveInfo.email} placeholder="Email" onChange={e => this.handleInputChange(e)}
                                    // disabled={EditUser}
                                    ></input>
                                </div>
                                <div className="col-lg-6">
                                    <label className="form-label">Phone</label><br></br>
                                    <input type="text" className="form-control" name='telephone' value={this.state.techExecutiveInfo.telephone} placeholder="Phone" onChange={e => this.handleInputChange(e)}></input>
                                </div>
                                {/* <div className="col-lg-6">
                                    <label className="form-label">PIC Contact Details</label><br></br>
                                    <input type="text" className="form-control" name='picContactDetails' value={this.state.techExecutiveInfo.picContactDetails} placeholder="PIC Contact Details" onChange={e => this.handleInputChange(e)}></input>
                                </div> */}
                                <div className="col-lg-12 mt-2 search-filter-box">
                                    <div className="search-btn-col" style={{ textAlign: 'end' }}>
                                        {!EditUser ?
                                            <button className="btn btn-primary text-uppercase txtside-btn txtht-btn blue" type="submit" onClick={() => this.addTechExecutive()}> Add </button>
                                            :
                                            <button className="btn btn-primary text-uppercase txtside-btn txtht-btn blue" type="submit" onClick={() => this.updateTechExecutive()}> Update </button>
                                        }
                                        <button className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3" type="button" onClick={() => this.hideSidePanel()}> Cancel </button>
                                    </div>
                                </div>
                            </div>
                            {/* <div className="row">
                                <div className="col-lg-12 search-filter-box">
                                    <div className="search-btn-col" style={{ textAlign: 'end' }}>
                                        {!EditUser ?
                                            <button className="btn btn-primary text-uppercase txtside-btn txtht-btn blue" type="submit" onClick={() => this.addTechExecutive()}> Add </button>
                                            :
                                            <button className="btn btn-primary text-uppercase txtside-btn txtht-btn blue" type="submit" onClick={() => this.updateTechExecutive()}> Update </button>
                                        }
                                        <button className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3" type="button" onClick={() => this.hideSidePanel()}> Cancel </button>
                                    </div>
                                </div>
                            </div> */}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    }
}
function mapStateToProps(state) {
    return {
        fleetManagerList: state.MasterScreenReducer.fleetManagerlist,
        techSuperintendentList: state.MasterScreenReducer.TechSuperintendentlist,
        techExecutiveList: state.MasterScreenReducer.TechExecutivelist,
        techExecutiveDetail: state.MasterScreenReducer.TechExecutiveDetail,
        EditUser: state.MasterScreenReducer.EditUser
    }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EditExecutive));
